export class TrackHttpError{
    errorNumber:number | undefined;
    message:string | undefined;
    friendlyMessage:string | undefined;
} 